<template>
  <div ref="menu" class="menu-box">
    <img @click="handleMenuShow" v-if="!show" src="../assets/img/icon_menu.png" width="32" alt="">
    <img @click="handleMenuClose" v-else src="../assets/img/icon_menu_close.png" width="32" alt="">
    <ul v-if="show" class="nav-list clearfix">
      <li @click="handleMenuClose" v-for="(item, index) in navList" :key="index">
        <router-link :to="item.value">{{ item.label }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  data () {
    return {
      show: false,
      navList: [
        { value: '/', label: 'Home' },
        { value: '/about-project', label: 'About This Project' },
        { value: '/about-me', label: 'About Me' }
      ]
    }
  },
  mounted () {
    document.addEventListener('click', this.bodyCloseMenus)
  },
  destroyed () {
    document.removeEventListener('click', this.bodyCloseMenus)
  },
  methods: {
    handleMenuShow () {
      this.show = true
    },
    handleMenuClose () {
      this.show = false
    },
    bodyCloseMenus (e) {
      if (this.show) {
        let con = this.$refs.menu
        if (con) {
          if (!con.contains(e.target)) {
            this.show = false
          }
        }
      }
    }
  }
}
</script>
<style scoped>
  .menu-box {
    position: fixed;
    top: 25px;
    left: 25px;
    cursor: pointer;
  }

  .nav-list {
    margin-top: 20px;
    min-width: 240px;
    background: rgba(10, 12, 52, 0.8);
  }

  .nav-list li {
    font-weight: bold;
  }

  .nav-list li a {
    color: #D7D7D7;
    display: inline-block;
    padding: 20px;
  }

  .nav-list li:hover {
    background: rgba(10, 12, 52);
  }

  .nav-list li:hover a {
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue